import Cycled from 'cycled'
import random from 'just-random-integer'

const colors = {
  'accent': '#f0e9e3',
  'tan': '#cfbeaf',
  'red': '#fa4003',
  'blue': '#267dde',
  'yellow': '#ffed00',
  'green': '#45c905',
  'tan_10': '#bbad9e',
  'tan_20': '#a4968a',
  'tan_30': '#90857a',
  'tan_40': '#7d7369',
  'tan_50': '#676058',
  'tan_60': '#534c46',
  'tan_70': '#3d3933',
  'tan_80': '#292623',
  'tan_90': '#171514',
}

const cyclecolors = {
  'red': '#fa4003',
  'blue': '#267dde',
  'green': '#45c905'
}

const colorNames = Object.keys(cyclecolors)

const colorGenerator = new Cycled(colorNames)
colorGenerator.index = random(colorNames.length - 1)

export { colors as default, colors, colorGenerator }